import clevertap from 'clevertap-web-sdk';
import { CLEVERTAP_ACCOUNT_ID, CLEVERTAP_REGION, isCleaverTapEnabled } from '../../env';

let isInitialized = false;
let currentIdentity: string | null = null;

type CleverTapProfile = {
    Identity: string;
    [key: string]: string;
};

const CleverTapService = {
    /**
     * Initialize CleverTap ONCE (Anonymous)
     */
    init() {
        if (!isCleaverTapEnabled) return;
        if (typeof window === 'undefined' || isInitialized) return;

        if (!CLEVERTAP_ACCOUNT_ID || !CLEVERTAP_REGION) {
            return;
        }

        clevertap.init(CLEVERTAP_ACCOUNT_ID, CLEVERTAP_REGION);
        // Active want to debug logs for cleartap
        clevertap.setLogLevel(3);
        clevertap.spa = true;

        clevertap.privacy.push({ optOut: false });

        isInitialized = true;
    },

    /**
     * IDENTIFY user (LOGIN / SIGNUP)
     * MUST be called whenever identity is established
     */
    onUserLogin(profile: CleverTapProfile) {
        if (!isCleaverTapEnabled) return;

        if (!isInitialized || !profile?.Identity) return;

        // Prevent duplicate pushes for same user
        if (currentIdentity === profile.Identity) return;

        clevertap.onUserLogin.push({ Site: profile });
        currentIdentity = profile.Identity;

    },

    /**
     * Update profile AFTER login
     */
    pushProfile(profile: Omit<CleverTapProfile, 'Identity'>) {
        if (!isCleaverTapEnabled) return;
        if (!isInitialized || !currentIdentity) return;

        clevertap.profile.push({ Site: profile });
    },

    /**
     * Track events
     */
    trackEvent(eventName: string, props: Record<string, any> = {}) {
        if (!isCleaverTapEnabled) return;
        if (!isInitialized) return;
        clevertap.event.push(eventName, props);
    },
    

    /**
     * SPA Page view
     */
    trackPageView(path: string, extra?: Record<string, any>) {
        if (!isCleaverTapEnabled) return;
        this.trackEvent('Page Viewed', {
            page: path,
            ...extra,
        });
    },

    /**
     * Logout
     */
    logout() {
        if (!isCleaverTapEnabled) return;
        if (!isInitialized) return;

        clevertap.logout();
        currentIdentity = null;

        console.log('[CleverTap] Logged out');
    },
    pushEvent: (eventName: string, properties: any = {}) => {
        try {
          if (clevertap && clevertap.event) {
            clevertap.event.push(eventName, properties);
            console.log(`🚀 Event Pushed: ${eventName}`, properties);
          } else {
            console.warn("CleverTap SDK not initialized");
          }
        } catch (error) {
          console.error("Error pushing CleverTap event:", error);
        }
      },

};

export default CleverTapService;